// extracted by mini-css-extract-plugin
module.exports = {"root":"_24NHe","transform":"QsRT7","swipeable":"Qe64r","preview":"_18Wef","next":"_31iDw","prev":"_1YaJE"};